// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__wubCe","title":"ClientReferral_title__2QKiW","itemText":"ClientReferral_itemText__2fNXg"};